import GET from "./api/GET";
import POST from "./api/POST";
import PUT from "./api/PUT";
import PATCH from "./api/PATCH";

export const fetchEmployees = async (
  page = 1,
  limit = process.env.REACT_APP_PAGINATION_LIMIT || 10,
  search
) => {
  const currentBranchData = localStorage.getItem(
    "wow-delivery-kw-merchant-current-branch"
  );
  const branchId = JSON.parse(currentBranchData)?._id;
  const response = await GET(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/employee/get?branchId=${branchId}&page=${page}&limit=${limit}&search=${search}`
  );
  return response;
};

export const fetchAllEmployees = async () => {
  const currentBranchData = localStorage.getItem(
    "wow-delivery-kw-merchant-current-branch"
  );
  const branchId = JSON.parse(currentBranchData)?._id;
  const response = await GET(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/employee/all?branchId=${branchId}`
  );
  return response;
};

export const createNewEmployee = async (credentials) => {
  const response = await POST(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/employee/create`,
    { ...credentials }
  );
  return response;
};

export const editEmployee = async (credentials) => {
  const response = await PUT(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/employee/update/${credentials?._id}`,
    { ...credentials }
  );
  return response;
};

export const resetEmployeePassword = async (credentials) => {
  const response = await PATCH(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/employee/reset-password/${credentials?._id}`,
    { ...credentials }
  );
  return response;
};

export const archiveEmployee = async (credentials) => {
  const response = await PATCH(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/employee/archive-employee/${credentials?._id}`,
    { ...credentials }
  );
  return response;
};

export const restoreEmployee = async (credentials) => {
  const response = await PATCH(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/employee/restore-employee/${credentials?._id}`,
    { ...credentials }
  );
  return response;
};
